import React, { useEffect } from 'react';
import { getLoadedComponent } from '../../../config/omni';
import useNavigate from '../../../hooks/useNavigate';
import * as S from '../FaqPageStyles';

const FrequentAskQuestion = ({cabFaqData = []}) => {

    useEffect(() => {
      getLoadedComponent('FrequentAskQuestion')
    }, [])

    const [navigateTo] = useNavigate();

    return (
      <S.FrequentAskQuestion onClick={() => {
        navigateTo("faq");
      }}>
        <S.TopContainer>
          <S.FrequentAskQuestionImg>
            <img src={"https://gos3.ibcdn.com/cabs-faq-1695812583.png"}/>
          </S.FrequentAskQuestionImg>
          <div>
            <S.FrequentAskQuestionTitle>
              Frequently Asked Questions
            </S.FrequentAskQuestionTitle>
            <S.FrequentAskQuestionSubtitle>
              Most common user concern and answers
            </S.FrequentAskQuestionSubtitle>
          </div>
        </S.TopContainer>
        <S.QuestionAnswerContainer>
        {cabFaqData?.length ? (
          <>
            <S.QuestionContainer>
              <span>Q.</span>
              {cabFaqData[0]?.question}
            </S.QuestionContainer>
            <S.AnswerContainer>
              {cabFaqData[0]?.answer}
            </S.AnswerContainer>
          </>
        ) : null}
        </S.QuestionAnswerContainer>
        <S.FrequentAskQuestionViewAll>
          View All &gt;
        </S.FrequentAskQuestionViewAll>
      </S.FrequentAskQuestion>
    );
}


export default FrequentAskQuestion;
